export default __webpack_public_path__ + "static/nodejs-logo-882dcf1de7bb331cd45bddc3ab3cdacc.png";